import { render, staticRenderFns } from "./ProductReturn.vue?vue&type=template&id=6fdfee04&scoped=true"
import script from "./ProductReturn.vue?vue&type=script&lang=js"
export * from "./ProductReturn.vue?vue&type=script&lang=js"
import style0 from "../../../assets/styles/inventory.css?vue&type=style&index=0&id=6fdfee04&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdfee04",
  null
  
)

export default component.exports